import { render, staticRenderFns } from "./SithMesInventoryOutdoorProductDetailList.vue?vue&type=template&id=4874b476&"
import script from "./SithMesInventoryOutdoorProductDetailList.vue?vue&type=script&lang=js&"
export * from "./SithMesInventoryOutdoorProductDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports